import { EN } from 'lib/locales';
import {
  VISITED_APP,
  VISITED_COMPONENT,
  VISITED_CONTRACT,
  VISITED_FOLDER,
  VISITED_LOGIN,
  VISITED_LOGOUT,
  VISITED_NAUTH,
  VISITED_PAGE,
  VISITED_REPORTS,
  VISITED_ROOT,
  VISITED_SEARCH
} from './const';

/**
 * visit the app
 * @returns {object} an action object
 */
export const visitApp = () => ({ type: VISITED_APP });

/**
 * visit the component route with a specific component
 * @param {string} id - id of the component
 * @param {string} version - version of the component
 * @param {string} locale - locale of the component
 * @returns {object} an action object
 */
export const visitComponent = (id, version, locale = EN) => ({
  type: VISITED_COMPONENT,
  payload: {
    id,
    query: {
      version,
      locale
    }
  }
});

/**
 * visit the contract preview view
 * @param {string} value - contract string to preview
 * @returns {object} an action object
 */
export const visitContract = value => ({
  type: VISITED_CONTRACT,
  query: {
    value
  }
});

/**
 * visit the folder route with a specific folder
 * @param {string} id - id of the folder to visit
 * @returns {object} an action object
 */
export const visitFolder = id => ({
  type: VISITED_FOLDER,
  payload: {
    id
  }
});

/**
 * visit the login route
 * @param {object} params - object of function params
 * @param {string} params.encodedAction - a uri-encoded stringified json object
 * @param {boolean} [params.sso = true] - whether nauth should check for signle sign on
 * @returns {object} an action object
 */
export const visitLogin = ({ encodedAction, sso = true } = {}) => ({
  type: VISITED_LOGIN,
  query: {
    encodedAction,
    sso
  }
});

/**
 * visit the logout route
 * @returns {object} an action object
 */
export const visitLogout = () => ({ type: VISITED_LOGOUT });

/**
 * visit the nauth route
 * @returns {object} an action object
 */
export const visitNauth = () => ({ type: VISITED_NAUTH });

/**
 * visit the page route with a specific page
 * @param {string} id - id of the page
 * @param {string} version - version of the page
 * @param {string} locale - locale of the component
 * @returns {object} an action object
 */
export const visitPage = (id, version, locale = EN) => ({
  type: VISITED_PAGE,
  payload: {
    id,
    query: {
      version,
      locale
    }
  }
});

/**
 * visit published pages report
 * @param {string} reportName - name of the report
 * @returns {object} an action object
 */
export const visitReports = reportName => ({
  type: VISITED_REPORTS,
  payload: {
    reportName
  }
});

/**
 * visit the root route
 * @returns {object} an action object
 */
export const visitRoot = () => ({ type: VISITED_ROOT });

/**
 * visit the search route
 * @param {string} context - the search context
 * @param {Array} filters - an array of filter objects
 * @returns {object} an action object
 */
export const visitSearch = (context, filters) => ({
  type: VISITED_SEARCH,
  query: {
    context,
    filters: JSON.stringify(filters)
  }
});
